import React from 'react';
import styles from './style.module.css';
import StepSevenForm from '../../components/forms/step-seven';

export default () => (
    <div className={styles.page}>
        <h1 className={styles.mainTitle}>Mortgage Term</h1>
        <StepSevenForm/>
    </div>
);
